import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import authReducer from 'auth/state/authReducers'
import appReducer from './appReducer'
import LoginReducer from '../pages/Login/module'
import * as newReducers from '../../state/reducers'
import { annotatorReducer } from '../../views/pages/Annotation/state'
import kardiaRxReducers from '../../views/state/index'
import appointmentNotificationsSettings from '../../views/state/TeamSettings/TeamSettingsReducers'
import patientEnrollment from '../../views/state/PatientEnrollment/PatientEnrollmentReducers'

const makeRootReducer = asyncReducers =>
  combineReducers({
    ...newReducers,
    auth: authReducer,
    app: appReducer,
    login: LoginReducer,
    kardiaRx: kardiaRxReducers,
    form: formReducer,
    annotator: annotatorReducer,
    teamSettings: appointmentNotificationsSettings,
    idtfPatientEnrollment: patientEnrollment,
    ...asyncReducers,
  })

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/legacy/store/reducers.js